import "./RQRamittanceDataGridStyle.css";

import { Box, CircularProgress, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	RHookFormNumberField,
	RequestParams,
} from "@websential/cosmic-v20";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatAmountCommaSeperator, formatDate, formatDateToShow, formatThousandSeperatorWithTwoFixedAmount } from "../../../common/Common";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import isEqual from "lodash/isEqual";

export interface IRQRamittanceDataGrid {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	whiteSpace?: string;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	rqRamittanceSetupTableData: (data: any) => void;
}

export const RQRamittanceDataGrid: React.FC<IRQRamittanceDataGrid> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	rqRamittanceSetupTableData,
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const [rqRemittanceItems, setRQRemittanceItems] = useState<any>(
		rows && rows
	);

	useEffect(() => {
		rqRamittanceSetupTableData(rqRemittanceItems);

	}, [rqRemittanceItems]);

	useEffect(() => {
		if (!isEqual(rows, rqRemittanceItems)) {
			setRQRemittanceItems([...rows]);
		}
	}, [rows]);

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedAuditEarningsItems, setSelectedAuditEarningsItems] =
		useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);
	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{ display: "flex", marginLeft: "10px", height: "37px" }}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding:"8px 10px 8px 10px",
								padding: "10px 22px 10px 10px",
								// marginRight:"-14px!important",
								borderRadius: "0px 2px 2px 0px",
								// backgroundColor: theme.palette.primary.main
							}}
						>
							{/* <SearchIcon /> */}
							Search
						</Button>
					</span>
				)}
				{/* {selectedItems.length > 0 ?
                        (
                          <>
                        <Button
                          icon="pi pi-trash"
                          onClick={() =>
                            onRowDeleteClicked(selectedItems)
                          }
                          severity="danger"
                        />
                          </>
                        ):(<></>)} */}
				{selectionToolbar && selectionToolbar(selectedItemsIds)}
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.clientName.props.children
						.toLowerCase()
						.indexOf(itemSearsch.toLowerCase()) > -1
			)
		);
	}
	// Custom column for row indices
	const indexColumn = {
		body: (rowData: any, row: any) => {
			return <span>{row.rowIndex + 1}</span>; // +1 to start indexing from 1 instead of 0
		},
		header: "#",
	};

	const onPage = (event: any) => {
		// setRequestParams(event);
		setLoading(true);
		//imitate delay of a backend call
		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				// Toggle sortOrder between 1 and -1
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				// Set the new sortField and reset sortOrder to 1
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}


			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			// Imitate delay of a backend call
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		},
		[sortOrder, sortField]
	);
	// This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
	useEffect(() => {
		// if the results fetcher was passed, we can use it to fetch the results.
		if (onRequestParamsChange) {
			// skip the first initial call
			if (isInitialRequest.current === true) {

				isInitialRequest.current = false;
			} else {

				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});

		}

	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			// setSelectedItems(selectedItemsIds);
			// Check for deleted items and remove them from selectedItems
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedAuditEarningsItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);

				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);
	useEffect(() => {
		// Check for deleted items and remove them from selectedItems
		const updatedSelectedItems =
			selectedItems &&
			selectedItems.length > 0 &&
			selectedItems.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
		// Only update if there are changes to selectedItems
		if (
			updatedSelectedItems &&
			updatedSelectedItems.length !== selectedItems.length
		) {
			setSelectedItems(updatedSelectedItems);

			// Update selectedItemsIds
			const updatedSelectedItemsIds = updatedSelectedItems.map(
				(item: any) => item.id
			);
			setSelectedItemsIds(updatedSelectedItemsIds);
		}
	}, [rows, selectedItems, selectedAuditEarningsItems]);

	const onCellEditComplete = (e: any) => {
		const { rowData, newValue, field, originalEvent: event } = e;

		if (!rowData.canEdit) {
			event.preventDefault();
			return;
		}

		if (field === "chequeDate") {
			rowData[field] = formatDate(newValue);
		} else if (
			newValue === null ||
			(typeof newValue === "string" && newValue.trim().length === 0)
		) {
			event.preventDefault();
			return;
		}

		setRQRemittanceItems((prev: any[]) => [...prev]);
	};

	const cellEditor = (options: any) => {
		if (options.field === "remitAmount" && !options.rowData.canEdit)
			return options.value !== null && options.value !== undefined
				? Number(options.value)
					.toFixed(2)
					.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				: "";
		if (options.field === "remitAmount" && options.rowData.canEdit)
			return NumberFieldEditor(options);
		if (options.field === "penaltyPaid" && !options.rowData.canEdit)
			return options.value !== null && options.value !== undefined
				? Number(options.value)
					.toFixed(2)
					.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				: "";
		if (options.field === "penaltyPaid" && options.rowData.canEdit)
			return NumberFieldEditor(options);
		if (options.field === "chequeNo" && !options.rowData.canEdit)
			return options.value;
		if (options.field === "chequeNo" && options.rowData.canEdit)
			return textEditor(options);
		if (options.field === "chequeDate" && !options.rowData.canEdit)
			return formatDateToShow(options.value);
		if (options.field === "chequeDate" && options.rowData.canEdit)
			return DateEditor(options);
		if (options.field === "penaltyPercentage" && !options.rowData.canEdit)
			return options.value !== null && options.value !== undefined
				? `${options.value}%`
				: "";
		if (options.field === "penaltyPercentage" && options.rowData.canEdit)
			return penaltyPercentageDdlEditor(options);
		else return <span>{options.value}</span>;
		// else return textEditor(options);
	};
	const textEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;

			setRQRemittanceItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputText
				value={options.value}
				onChange={handleChange}
				onKeyDown={(e) => e.stopPropagation()}
			/>
		);
	};

	const NumberFieldEditor = (options: any) => {
		const { rowData, field } = options;

		const handleChange = (e: any) => {
			const value = e.value;

			setRQRemittanceItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex((item) => item.id === rowData.id);
				if (index !== -1) {
					updated[index] = { ...updated[index], [field]: value };
				}
				return updated;
			});

			options.editorCallback(value);
		};

		return (
			<InputNumber
				value={options.value}
				onChange={handleChange}
				placeholder="0.00"
				minFractionDigits={2}
				maxFractionDigits={2}
				inputStyle={{ textAlign: "right" }}
			/>
		);
	};

	const penaltyPercentageDdlEditor = (options: any) => {


		const { rowData, editorCallback } = options;

		const onChange = (e: any) => {
			const newValue = e.value;

			// Copy the entire array
			setRQRemittanceItems((prev: any[]) => {
				const updated = [...prev];

				// Find index of the row we're editing
				const rowIndex = updated.findIndex((item) => item.id === rowData.id);
				if (rowIndex !== -1) {
					updated[rowIndex] = {
						...updated[rowIndex],
						penaltyPercentage: newValue,
						penaltyCalculated: ((rowData.dueDoller || 0) * newValue) / 100,
					};
				}


				return updated;
			});

			// PrimeReact still needs this to commit the cell edit
			editorCallback(newValue);
		};

		return (
			<Dropdown
				options={[
					{ label: "0%", value: 0 },
					{ label: "3%", value: 3 },
					{ label: "5%", value: 5 },
					{ label: "7%", value: 7 },
					{ label: "10%", value: 10 },
				]}
				value={options.value ?? 0}
				onChange={onChange}
				onKeyDown={(e) => e.stopPropagation()}
				style={{ width: "100%" }}
			/>
		);
	};

	const DateEditor = (options: any) => {
		const handleChange = (e: any) => {
			const newDate = e.value;

			setRQRemittanceItems((prev: any[]) => {
				const updated = [...prev];
				const index = updated.findIndex(
					(item) => item.id === options.rowData.id
				);
				if (index !== -1) {
					updated[index] = { ...updated[index], chequeDate: newDate };
				}
				return updated;
			});

			options.editorCallback(newDate);
		};

		return (
			<div onClick={(e) => e.stopPropagation()}>
				<Calendar
					value={options.value}
					onChange={handleChange}
					dateFormat="M dd, yy"
					showButtonBar
					placeholder="M dd, yyyy"
				/>
			</div>
		);
	};

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		setRQRemittanceItems((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		// if we are using editable mode cell and using cell editor then we use this code
		// if (x.field === "totalRemitted") {
		// 	if (rowData.canDelete) {
		// 		return (
		// 			<div>
		// 				<span>
		// 					$&nbsp;
		// 					{rowData[x.field] !== null
		// 						? rowData[x.field]
		// 								.toFixed(2)
		// 								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		// 						: rowData[x.field]}
		// 				</span>
		// 				{managedBy !== 100 ? (
		// 					<EnhancedButtonPrimeReact
		// 						// icon="pi pi-trash"
		// 						icon="pi pi-times"
		// 						onClickHandler={() =>
		// 							onRowDeleteClicked && onRowDeleteClicked(rowData)
		// 						}
		// 						severity={EnhancedButtonPrimeReactSeverity.Danger}
		// 						className="p-button-rounded p-button-text w-2rem h-1rem deleteButton"
		// 						rounded
		// 					/>
		// 				) : (
		// 					<></>
		// 				)}
		// 			</div>
		// 		);
		// 	} else {
		// 		return (
		// 			<span>
		// 				$&nbsp;
		// 				{rowData[x.field] !== null
		// 					? rowData[x.field]
		// 							.toFixed(2)
		// 							.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		// 					: rowData[x.field]}
		// 			</span>
		// 		);
		// 	}
		// }
		// if (x.field === "shortExcess" || x.field === "balance") {
		// 	if (rowData[x.field] < 0) {
		// 		return (
		// 			<span style={{ color: "red" }}>
		// 				$&nbsp;
		// 				{rowData[x.field] !== null
		// 					? rowData[x.field]
		// 							.toFixed(2)
		// 							.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		// 					: rowData[x.field]}
		// 			</span>
		// 		);
		// 	} else {
		// 		return (
		// 			<span>
		// 				$&nbsp;
		// 				{rowData[x.field] !== null
		// 					? rowData[x.field]
		// 							.toFixed(2)
		// 							.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		// 					: rowData[x.field]}
		// 			</span>
		// 		);
		// 	}
		// }
		// if (x.field === "chequeDate") {
		// 	return formatDateToShow(rowData[x.field]);
		// }
		// if (x.field === "penaltyPercentage") {
		// 	if (rowData[x.field] && rowData[x.field] !== null) {
		// 		return <span>{rowData[x.field]}%</span>;
		// 	} else {
		// 		return <span>{rowData[x.field]}</span>;
		// 	}
		// }

		// if (
		// 	x.field === "period" ||
		// 	x.field === "dueDate" ||
		// 	x.field === "remitDate" ||
		// 	x.field === "status" ||
		// 	x.field === "emp" ||
		// 	x.field === "chequeNo"
		// ) {
		// 	return <span>{rowData[x.field]}</span>;
		// }
		// if (
		// 	x.field === "adj" ||
		// 	x.field === "remitAmount" ||
		// 	x.field === "penaltyPaid"
		// ) {
		// 	return (
		// 		<span>
		// 			{rowData[x.field] !== null
		// 				? rowData[x.field].toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		// 				: rowData[x.field]}
		// 		</span>
		// 	);
		// }
		// if (
		// 	x.field === "dueAmount" ||
		// 	x.field === "rqCredit" ||
		// 	x.field === "dueDoller" ||
		// 	x.field === "penaltyCalculated"
		// ) {
		// 	return (
		// 		<span>
		// 			{rowData[x.field] !== null
		// 				? `$ ${rowData[x.field]
		// 						.toFixed(2)
		// 						.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
		// 				: rowData[x.field]}
		// 		</span>
		// 	);
		// }

		// And if we are using column body only then we have to use this
		if (x.field === "totalRemitted") {
			if (rowData.canDelete) {
				return (
					<div>
						<span>
							{rowData[x.field] && rowData[x.field] !== null
								? `$ ${rowData[x.field]
									.toFixed(2)
									.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
								: rowData[x.field]}
						</span>
						<EnhancedButtonPrimeReact
							// icon="pi pi-trash"
							icon="pi pi-times"
							onClickHandler={() =>
								onRowDeleteClicked && onRowDeleteClicked(rowData)
							}
							severity={EnhancedButtonPrimeReactSeverity.Danger}
							className="p-button-rounded p-button-text w-2rem h-1rem deleteButton"
							rounded
						/>
					</div>
				);
			} else {
				return (
					<span>
						{rowData[x.field] !== null
							? `$ ${rowData[x.field]
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
							: rowData[x.field]}
					</span>
				);
			}
		}
		if (x.field === "shortExcess" || x.field === "balance") {
			if (rowData[x.field] < 0) {
				return (
					<span style={{ color: "red" }}>
						{rowData[x.field] !== null
							? `$ ${rowData[x.field]
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
							: rowData[x.field]}
					</span>
				);
			} else {
				return (
					<span>
						{rowData[x.field] !== null
							? `$ ${rowData[x.field]
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
							: rowData[x.field]}
					</span>
				);
			}
		}
		if (x.field === "chequeDate") {
			if (rowData.canEdit) {
				return (
					<Calendar
						value={rowData[x.field]}
						// className="calender"
						style={{
							margin: "8px 0px 4px 0px",
							width: "auto",
						}}
						onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
						dateFormat="M dd, yy"
						placeholder={"dd/mm/yyyy"}
						showButtonBar
					// className={renderErrorClass(x, row.rowIndex,rowData)}
					/>
				);
			} else {
				return formatDateToShow(rowData[x.field]);
			}
		}
		if (x.field === "penaltyPercentage") {
			if (rowData.canEdit) {
				const onChange = (e: any) => {
					const newValue = e.value;

					// Copy the entire array
					setRQRemittanceItems((prev: any[]) => {
						const updated = [...prev];

						// Find index of the row we're editing
						const rowIndex = updated.findIndex(
							(item) => item.id === rowData.id
						);
						if (rowIndex !== -1) {
							updated[rowIndex] = {
								...updated[rowIndex],
								penaltyPercentage: newValue,
								penaltyCalculated: ((rowData.dueDoller || 0) * newValue) / 100,
							};
						}
						return updated;
					});
				};

				return (
					<Dropdown
						options={[
							{ label: "0%", value: 0 },
							{ label: "3%", value: 3 },
							{ label: "5%", value: 5 },
							{ label: "7%", value: 7 },
							{ label: "10%", value: 10 },
						]}
						value={rowData.penaltyPercentage ?? 0}
						onChange={onChange}
						onKeyDown={(e) => e.stopPropagation()}
						style={{ width: "100%" }}
					/>
				);
			} else if (rowData[x.field] && rowData[x.field] !== null) {
				return <span>{rowData[x.field]}%</span>;
			} else {
				return <span>{rowData[x.field]}</span>;
			}
		}

		if (
			x.field === "period" ||
			x.field === "dueDate" ||
			x.field === "remitDate" ||
			x.field === "status" ||
			x.field === "emp"
		) {
			return <span>{rowData[x.field]}</span>;
		}
		if (x.field === "remitAmount") {
			if (rowData.canEdit) {
				return (
					<InputNumber
						value={rowData.remitAmount}
						onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
						placeholder="0.00"
						minFractionDigits={2}
						maxFractionDigits={2}
						inputStyle={{ textAlign: "right" }}
					/>
				);
			} else {
				return (
					<span>
						{rowData[x.field] !== null
							? rowData[x.field]
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							: rowData[x.field]}
					</span>
				);
			}
		}
		if (x.field === "penaltyPaid") {
			if (rowData.canEdit) {
				return (
					<InputNumber
						value={rowData.penaltyPaid}
						onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
						placeholder="0.00"
						minFractionDigits={2}
						maxFractionDigits={2}
						inputClassName="penaltyPaidInputField"
						inputStyle={{ textAlign: "right" }}
					/>
				);
			} else {
				return (
					<span>
						{rowData[x.field] && rowData[x.field] !== null
							? rowData[x.field]
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							: rowData[x.field]}
					</span>
				);
			}
		}
		if (x.field === "chequeNo") {
			if (rowData.canEdit) {
				return (
					<InputText
						value={rowData[x.field]}
						onChange={(e: any) =>
							onCellValueChange(x, row.rowIndex, e.target.value)
						}
						className={'chequeNoInputField'}
					// style={{ maxWidth: "82px!important",minWidth: "82px!important" }}
					/>
				);
			} else {
				return <span>{rowData[x.field]}</span>;
			}
		}
		if (x.field === "adj") {
			return (
				// <span>
				// 	{rowData[x.field] && rowData[x.field] !== null
				// 		? rowData[x.field].toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
				// 		: rowData[x.field]}
				// </span>
				<span>
					{rowData[x.field] !== null && rowData[x.field] !== undefined
						? `$ ${formatAmountCommaSeperator(rowData[x.field])}`
						: rowData[x.field]}
				</span>
			);
		}
		if (
			x.field === "dueAmount" ||
			x.field === "rqCredit" ||
			x.field === "dueDoller" ||
			x.field === "csstAmount" ||
			x.field === "hsfAmount" ||
			x.field === "penaltyCalculated"
		) {
			return (
				// <span>
				// 	{rowData[x.field] && rowData[x.field] !== null
				// 		? `$ ${rowData[x.field]
				// 			.toFixed(2)
				// 			.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
				// 		: rowData[x.field]}
				// </span>
				<span>
					{rowData[x.field] !== null && rowData[x.field] !== undefined
						? `$ ${formatAmountCommaSeperator(rowData[x.field])}`
						: rowData[x.field]}
				</span>
			);
		}
		return <span>{rowData[x.field]}</span>;  // add to show default data 
	};

	const printPD7Body = (params: any) => {

		return (
			<>
				{params.remitAmount !== null ? (
					<div
						style={{
							display: "flex",
							height: "35px",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<p
							style={{ color: "#0091b3", cursor: "pointer" }}
							onClick={() => alert("Generic Clicked")}
						>
							Generic
						</p>
						&nbsp;<p>/</p>&nbsp;
						<p
							style={{ color: "#0091b3", cursor: "pointer" }}
							onClick={() => alert("Post Clicked")}
						>
							Post
						</p>
						&nbsp;<p>/</p>&nbsp;
						<p
							style={{ color: "#0091b3", cursor: "pointer" }}
							onClick={() => alert("Cheque Clicked")}
						>
							Cheque
						</p>
					</div>
				) : (
					<div
						style={{
							display: "flex",
							height: "35px",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<p
							style={{ color: "#0091b3", cursor: "pointer" }}
							onClick={() => alert("Generic Clicked")}
						>
							Generic
						</p>
						&nbsp;<p>/</p>&nbsp;
						<p
							style={{ color: "#0091b3", cursor: "pointer" }}
							onClick={() => alert("Post Clicked")}
						>
							Post
						</p>
					</div>
				)}
			</>
		);
	};

	const shortExcessColumnFooter = (value: number) => {
		if (value < 0) {
			return (
				<>
					Bal: <span style={{ color: "red" }}>
						{formatThousandSeperatorWithTwoFixedAmount(value)}
					</span></>
			);
		} else {
			return (
				<span>
					Bal: {formatThousandSeperatorWithTwoFixedAmount(value)}
				</span>
			);
		}
	};




	return (
		<>
			<DataTable
				value={rows && columns && rqRemittanceItems}
				responsiveLayout="scroll"
				// editMode={managedBy !== 100 ? "cell" : undefined} //non-editable for managed by simplepay
				showGridlines
				resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// reorderableColumns
				loading={isLoading ? isLoading : loading}
				footer={footer ? footer : undefined}
				emptyMessage="No Record found."
				className="RQDataGrid"
				style={{
					margin: `${tableMargin ? tableMargin : "14px 0.5rem 0.5rem 0"}`,
				}}
				sortMode="single"
			>
				{rows && rows.length ? (
					<Column
						header="#"
						className="indexColumn"
						headerClassName="indexColumn"
						headerStyle={{ width: "24px" }}
						frozen
						hidden={!showIndexColumn}
						body={(data, options) => options.rowIndex + 1}
					></Column>
				) : undefined}
				{columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							// const editableFields = new Set([
							// 	"remitAmount",
							// 	"penaltyPercentage",
							// 	"penaltyPaid",
							// 	"chequeNo",
							// 	"chequeDate",
							// ]);
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									// sortable={x.sortable}
									reorderable={false}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									exportable={x.disableExport}
									frozen={x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
										maxWidth: x.maxWidth,
									}}
									headerStyle={{
										whiteSpace: whiteSpace ? whiteSpace : "nowrap",
									}}
									footer={x.field === 'shortExcess' ? shortExcessColumnFooter(x.footer) : formatThousandSeperatorWithTwoFixedAmount(x.footer)}
									// editor={editableFields.has(x.field) ? cellEditor : undefined}
									// onCellEditComplete={onCellEditComplete}
									// bodyClassName={(rowData: any) =>
									// 	editableFields.has(x.field) && rowData.canEdit
									// 		? "editable-cell"
									// 		: ""
									// }
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}

				{rows && rows.length ? (
					<Column
						body={printPD7Body}
						header={"Print"}
						// style={{
						// 	width: "36px",
						// }}
						resizeable={false}
						reorderable={false}
						frozen
						alignFrozen="right"
						// className="settingHeader"
						headerClassName="printPD7ColumnHeader"
					></Column>
				) : undefined}
			</DataTable>
		</>
	);
};
